__turbopack_context__.v({
  "button": "Modal-module-scss-module__7UGbvq__button",
  "closeButton": "Modal-module-scss-module__7UGbvq__closeButton",
  "dialogComponent": "Modal-module-scss-module__7UGbvq__dialogComponent",
  "modal": "Modal-module-scss-module__7UGbvq__modal",
  "modalMain": "Modal-module-scss-module__7UGbvq__modalMain",
  "overlay": "Modal-module-scss-module__7UGbvq__overlay",
  "size": "Modal-module-scss-module__7UGbvq__size",
});
